import Page from './index.vue'
export default { path: '/home/abnormalAsset', component: Page }
